module.exports = __webpack_public_path__ + "img/blue.757e7611.png";